import { useAppDispatch } from 'app/hooks'
import { CountType } from 'enums'
import { getWidgetForDashboard } from 'features/widget/asyncThunks'
import { useDashboardData, useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { useEffect } from 'react'
import { Dashboard } from 'schemas/DashboardSchema'
import { createInsightCount } from 'utils/runSearchUtil'
import { toFilter } from 'utils/widgetUtil'
import { getMeasureByCountTypeAndAnalysisType } from 'utils/measureUtil'
import { getEmojiCategory, getInsightCategory } from 'utils/viewOptionUtil'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'
import { WidgetId } from 'features/types'

import { IndexWidgetsType } from '../../types'

const createSearches = (widgetSetting: IndexWidgetsType, dashboardData: Dashboard) => {
  const {
    selectedTopic,
    precision,
    viewOption,
    countType,
    analysisType,
    comparedTopicInfos,
    topN
  } = widgetSetting

  let showPrimaryTerms: boolean | undefined
  if ('showPrimaryTerms' in widgetSetting) {
    showPrimaryTerms = widgetSetting.showPrimaryTerms
  }

  const filter = toFilter(widgetSetting)
  const topicIds = [selectedTopic.topicId!]
  const comparedIds =
    comparedTopicInfos && comparedTopicInfos.length
      ? [comparedTopicInfos![0].topicId!]
      : [selectedTopic.topicId]
  const { id: dashboardId, name } = dashboardData
  const measure = getMeasureByCountTypeAndAnalysisType(countType!, analysisType!)
  const insightCountOption = {
    showPrimaryObject: showPrimaryTerms,
    isAuthorBased: countType === CountType.AUTHORS,
    exactCount: topN,
    comparedTopicIds: comparedIds,
    emojiCategory: getEmojiCategory(viewOption)
  }

  return createInsightCount(
    dashboardId!,
    name!,
    precision!,
    topicIds,
    filter,
    measure!,
    getInsightCategory(viewOption!, analysisType!),
    insightCountOption
  )
}

const RunSearchEffect = ({
  widgetId,
  children
}: {
  widgetId: WidgetId
  children: React.ReactElement
}) => {
  const widgetSetting = useDashboardWidgetSetting<IndexWidgetsType>(widgetId)
  const dashboardData = useDashboardData()
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const search = createSearches(widgetSetting, dashboardData!)

    dispatch(
      getWidgetForDashboard({
        searches: [search],
        widgetId: widgetSetting.widgetId!,
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardData, dispatch, refreshTimestamp])

  return children
}

export default RunSearchEffect
